import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote } from "lucide-react";

export default function QuoteOfDay() {
  const [q, setQ] = useState(null);
  useEffect(() => { api.get("/quotes/today").then((r) => setQ(r.data)).catch(() => {}); }, []);
  if (!q) return null;

  return (
    <section data-testid="quote-of-day" className="max-w-7xl mx-auto px-6 md:px-10 py-14">
      <div className="border-l-2 border-[var(--terracotta)] pl-8 md:pl-12 py-2 max-w-4xl mx-auto">
        <div className="flex items-start gap-4">
          <Quote className="w-7 h-7 text-[var(--forest)]/40 mt-1 shrink-0" strokeWidth={1.5} />
          <div>
            <div className="overline mb-3">Today's reminder</div>
            <p className="font-serif-display text-2xl md:text-3xl lg:text-4xl italic leading-snug text-[var(--ink)]">
              &ldquo;{q.text}&rdquo;
            </p>
            {q.author && (
              <div className="mt-4 font-mono-acc text-xs tracking-[0.18em] uppercase text-[var(--ink-soft)]">
                — {q.author}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
